export default __webpack_public_path__ + "static/media/liverpoolHover.07ce8a34.svg";